<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button
            @click="$utils.goBack($router)"
            text="Quay lại"
            defaultHref="/tabs/main"
          ></ion-back-button>
        </ion-buttons>
        <ion-title>Đặt vé</ion-title>
        <ion-label slot="end" style="margin-right: 2vw"></ion-label>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <GameTitle game="power"></GameTitle>
      <div v-if="loaded">
        <div class="options ion-padding">
          <div>
            <div>Cách chơi</div>
            <div>
              <MySelect2
                :options="subgameOptions"
                title="Chọn cách chơi"
                :value="subgame"
                @change="changeSubGame"
              ></MySelect2>
            </div>
          </div>
          <div>
            <div>Kỳ mua</div>
            <div>
              <StageSelector
                :options="stageOptions"
                :value="selectedStages"
                @change="changeStage"
                :key="updateKey"
              ></StageSelector>
            </div>
          </div>
        </div>
        <div class="game">
          <template v-for="(card, idx) in cards" :key="card.id">
            <div
              v-if="idx < linesToShow"
              class="gamecard ion-activatable"
              @click="editCard($event, idx)"
            >
              <span class="title">
                {{ card.id }}
              </span>
              <div class="balls">
                <span v-for="(val, bidx) in numsToPick" :key="val" class="ball">
                  <span class="balltext" v-if="card.nums.length > bidx">{{
                    card.nums[bidx] > 0 ? $utils.zpad2(card.nums[bidx]) : "TC"
                  }}</span>
                </span>
                <span v-if="subgame == 'pwcover5'" class="ball">
                  <span class="balltext">&#x2217;</span>
                </span>
              </div>
              <div class="buttons">
                <ion-button
                  color="danger"
                  v-if="!card.selected"
                  @click="debounceWizpick($event, idx)"
                  size="small"
                  fill="clear"
                >
                  <ion-icon :icon="dice" slot="icon-only"></ion-icon>
                </ion-button>
                <ion-button
                  color="danger"
                  v-if="card.selected"
                  @click="trashCard(card)"
                  size="small"
                  fill="clear"
                >
                  <ion-icon :icon="trash" slot="icon-only"></ion-icon>
                </ion-button>
              </div>
              <ion-ripple-effect></ion-ripple-effect>
            </div>
          </template>

          <div class="footbtns ion-padding">
            <div>
              <ion-button color="tertiary" expand="block" @click="wizpick"
                >Thần Tài Chọn</ion-button
              >
            </div>
            <div>
              <ion-button color="warning" expand="block" @click="mpick"
                >Máy Tự Chọn</ion-button
              >
            </div>
          </div>
        </div>
      </div>

      <support-button :showBg="true"></support-button>
      <anon-overlay></anon-overlay>
    </ion-content>
    <ion-footer v-if="loaded">
      <PaySlip
        game="power"
        :total="total"
        :feeAmount="feeAmount"
        :disabled="!purchasable"
        @confirmOrder="confirmOrder"
        :stage="parseInt(Object.keys(stageOptions)[0])"
      ></PaySlip>
    </ion-footer>
  </ion-page>
</template>


<style lang="scss" scoped>
.footbtns {
  display: flex;
  flex-direction: row;
  margin-bottom: 60px;
  > div {
    flex-grow: 1;
  }
}

MySelect2 {
  --bottom-padding: 0vh;
}

.options {
  display: flex;
  > div {
    margin: 0 1vw;
    flex: 1;
  }
  margin-bottom: 2vh;
}
.game {
  .gamecard {
    display: flex;
    flex-direction: columns;
    justify-content: space-between;
    border-bottom: 1px solid #aaa;
    position: relative;
    overflow: hidden;

    &:nth-child(1) {
      border-top: 1px solid #aaa;
    }

    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 7vw;
      color: #666;
      background-color: #ffc282;
    }

    .balls {
      display: grid;
      margin: 1vh 1vw;
      grid-template-columns: repeat(6, auto);
      grid-gap: 1vw;
      .ball {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 7.5vw;
        height: 7.5vw;
        font-size: 1.1em;
        border-radius: 100%;
        border: 1px solid;
      }
      .plus {
        display: flex;
        align-items: center;
        height: 7vw;
      }
    }

    .buttons {
      display: flex;
      flex-direction: row;
      margin: 1vw;
      min-width: 3.1rem;
      margin-right: 2vw;
      align-items: center;
      .dice,
      .trash {
        margin: 0 0.5vw;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 7vw;
        height: 7vw;
        border-radius: 100%;
        padding: 0;
        background-color: #ff992f;
        ion-icon {
          fill: #fff;
        }
      }
    }
  }
}
</style>

<script>
import {
  IonContent,
  IonToolbar,
  IonFooter,
  IonPage,
  IonHeader,
  IonButtons,
  IonButton,
  IonBackButton,
  IonTitle,
  IonLabel,
  IonIcon,
  IonRippleEffect,
  modalController,
} from "@ionic/vue";
import { helpCircle, dice, trash } from "ionicons/icons";
import { random } from "lodash";
import PowerPick from "./Pick.vue";
import { defineComponent } from "vue";
import MySelect2 from "@/components/MySelect2.vue";
import StageSelector from "@/components/StageSelector.vue";
import PaySlip from "@/components/PaySlip.vue";
import GameTitle from "@/components/GameTitle.vue";
import { cloneDeep, debounce } from "lodash";
import SupportButton from "@/components/SupportButton.vue";
import AnonOverlay from "@/components/AnonOverlay.vue";

export default defineComponent({
  name: "GamePower",
  components: {
    IonContent,
    IonToolbar,
    IonFooter,
    IonPage,
    IonHeader,
    IonButtons,
    IonButton,
    IonBackButton,
    IonTitle,
    IonLabel,
    IonIcon,
    IonRippleEffect,
    MySelect2,
    StageSelector,
    PaySlip,
    GameTitle,
    SupportButton,
    AnonOverlay,
  },
  data() {
    return {
      pickShowed: false,
      purchasable: false,
      loadingShowed: false,
      currentPickCard: 0,
      subgame: "power",
      cards: [],
      subgameOptions: {
        power: "Cơ bản",
        pwcover5: "Bao 5 Cuộn",
        pwcover7: "Bao 7",
        pwcover8: "Bao 8",
        pwcover9: "Bao 9",
        pwcover10: "Bao 10",
        pwcover11: "Bao 11",
        pwcover12: "Bao 12",
        pwcover13: "Bao 13",
        pwcover14: "Bao 14",
        pwcover15: "Bao 15",
        pwcover18: "Bao 18",
      },
      selectedStages: [],
      linesToShow: 6,
      updateKey: 1,
      total: 0,
      feeAmount: 0,
      showPrizeStruct: false,
      numsToPick: 6,
      loaded: false,
    };
  },
  computed: {
    stageOptions() {
      if (!this.loaded) return {};
      const opts = {};
      this.$store.state.fsdb.livePower.stages.forEach((stage) => {
        opts[stage.value] = {
          key: stage.value,
          display: stage.title,
          description: stage.display,
        };
      });

      return opts;
    },
  },
  watch: {
    stageOptions: function (newval) {
      const keys = Object.keys(newval);

      this.selectedStages.forEach((stg, idx, arr) => {
        if (!keys.includes(stg)) {
          arr.splice(idx, 1);
        }
      });

      if (this.selectedStages.length == 0) {
        this.selectedStages.push(Object.keys(newval)[0]);
      }

      console.log("selectedStages", this.selectedStages);

      this.forceUpdate();
    },
  },
  mounted() {
    this.resetCards();

    if (this.$route.query.payload && this.$route.path == "/power") {
      console.log(this.$route.query.payload);
      const payload = JSON.parse(decodeURI(this.$route.query.payload));
      if (payload.ticket.subgame != "power")
        this.changeSubGame(payload.ticket.subgame);

      const cardMap = {
        A: 0,
        B: 1,
        C: 2,
        D: 3,
        E: 4,
        F: 5,
      };

      payload.cards.forEach((card) => {
        this.cards[cardMap[card.name]].nums = cloneDeep(card.selection);
        if (card.selection[0] == 0) this.cards[cardMap[card.name]].mpick = true;
        this.cards[cardMap[card.name]].selected = true;
      });
      this.$nextTick(() => {
        this.loaded = true;
        this.$nextTick(() => {
          this.updateTotal();
        });
      });
    } else {
      this.$nextTick(() => {
        this.loaded = true;
      });
    }
  },
  methods: {
    debounceWizpick: debounce(
      async function (e = null, idx = null) {
        return this.wizpick(e, idx);
      },
      500,
      {
        leading: true,
        trailing: false,
      }
    ),
    forceUpdate() {
      this.updateKey += 1;
    },
    getAllSelection() {
      let selection = [];
      for (let i = 0; i < this.linesToShow; i++) {
        if (this.cards[i].selected) {
          selection = [...selection, ...this.cards[i].nums];
        }
      }
      return selection;
    },
    async wizpick(e = null, idx = null) {
      if (idx == null) for (let i = 0; i < this.linesToShow; i++) {
        if (!this.cards[i].selected) {
          idx = i;
          break;
        }
      }

      const index = idx;

      if (index != null) {
        await this.$utils.showLoading();
        this.$utils.callAPI2('POST', '/api/wizpick/power', {
          "stage": this.selectedStages && this.selectedStages.length > 0 ? parseInt(this.selectedStages[0]) : 0,
          "selection": this.getAllSelection(),
          "pick": this.numsToPick,
        }).then(async (resp) => {
          console.log(resp);
          console.log(index);
          this.cards[index].nums = resp.data.numbers;
          this.cards[index].selected = true;
          this.cards[index].mpick = 0;
          await this.$utils.hideLoading();
          this.updateTotal();
        }).catch(async () => {
          this.randomPick(this.cards[index]);
          await this.$utils.hideLoading();
        });

        return;
      }
    },
    mpick() {
      for (let i = 0; i < this.linesToShow; i++) {
        if (!this.cards[i].selected) {
          this.cards[i].mpick = this.numsToPick;
          this.cards[i].selected = true;
          this.cards[i].nums = Array(this.numsToPick).fill(0);
          this.updateTotal();
          return;
        }
      }
    },
    async openModal() {
      const modal = await modalController.create({
        component: PowerPick,
        cssClass: "transmodal modal-fullscreen",
        componentProps: {
          selectedStages: this.selectedStages,
          subgame: this.subgame,
          numsToPick: this.numsToPick,
          linesToShow: this.linesToShow,
          cards: this.cards,
          selectedIndex: this.currentPickCard,
        },
      });
      modal.onWillDismiss().then((resp) => {
        const data = resp.data;
        if (!data.cancel) {
          this.updateCards(data.dataCards);
        }
      });

      return modal.present();
    },
    changeStage(value) {
      this.selectedStages = value;
      this.updateTotal();
    },
    randomPick(card) {
      let picks = [];
      while (picks.length < this.numsToPick) {
        const pick = random(1, 55, false);
        if (!picks.includes(pick)) picks.push(pick);
      }
      picks = picks.sort((n1, n2) => n1 - n2);
      card.nums = picks;
      card.selected = true;
      this.updateTotal();
    },
    trashCard(card) {
      card.nums = [];
      card.selected = false;
      card.mpick = 0;
      this.updateTotal();
    },
    priceChanged(e, card) {
      card.price = e;
    },
    editCard(event, idx) {
      this.currentPickCard = idx;

      if (
        event.target.classList.contains("gamecard") ||
        event.target.classList.contains("balls") ||
        event.target.classList.contains("ball") ||
        event.target.classList.contains("title") ||
        event.target.classList.contains("balltext")
      ) {
        this.openModal();
      }
    },
    updateCards(cards) {
      this.pickShowed = false;
      this.cards = cards;
      this.updateTotal();
    },
    changeSubGame(newval) {
      this.subgame = newval;
      this.resetCards();
      this.updateTotal();
      if (this.subgame == "power") {
        this.numsToPick = 6;
      } else {
        this.numsToPick = parseInt(this.subgame.substring(7));
      }

      if (this.numsToPick >= 12) this.linesToShow = 1;
      else if (this.numsToPick >= 10) this.linesToShow = 3;
      else if (this.numsToPick >= 7) this.linesToShow = 5;
      else this.linesToShow = 6;
    },
    resetCards() {
      this.cards = [
        { id: "A", nums: [], price: 10, selected: false, mpick: 0 },
        { id: "B", nums: [], price: 10, selected: false, mpick: 0 },
        { id: "C", nums: [], price: 10, selected: false, mpick: 0 },
        { id: "D", nums: [], price: 10, selected: false, mpick: 0 },
        { id: "E", nums: [], price: 10, selected: false, mpick: 0 },
        { id: "F", nums: [], price: 10, selected: false, mpick: 0 },
      ];
      this.total = 0;
      this.purchasable = false;
    },
    updateTotal() {
      let combo = 1;
      if (this.subgame == "pwcover5") {
        combo = 50;
      } else {
        combo = this.calculateCombo(this.numsToPick, 6);
      }
      this.total = 0;
      this.showPrizeStruct = false;
      this.cards.forEach((item) => {
        if (item.selected == true) {
          this.total += item.price;
          this.showPrizeStruct = true;
        }
      });
      this.total = this.total * parseInt(this.selectedStages.length) * combo;
      this.feeAmount = this.total == 0 ? 0 : (parseFloat(this.$store.state.fsdb.liveConfig['power_fee'])/100.0) * this.total;
      this.total = this.total + this.feeAmount;
      this.purchasable = this.total > 0;
    },
    calculateCombo(n, r) {
      return this.factorial(n) / (this.factorial(r) * this.factorial(n - r));
    },
    factorial(num) {
      let val = 1;
      for (let i = 2; i <= num; i++) val = val * i;
      return val;
    },
    async confirmOrder() {
      const stages = [];
      for (let i = 1; i <= parseInt(this.selectedStages); i++) {
        stages.push(i);
      }
      const data = [];
      this.cards.forEach((item) => {
        if (item.selected == true) {
          delete item["selected"];
          data.push(item);
        }
      });
      if (data.length == 0) return;
      const obj = {
        subgame: this.subgame,
        level: this.level,
        stages: this.selectedStages,
        data: data,
      };

      let subgame = "";
      if (this.subgame == "power") {
        subgame = "pwbasic";
      } else {
        subgame = "pwcover";
      }

      this.$utils.showLoading();
      console.log("requesting create order api;");
      const resp = await this.$utils.callAPI("POST", "/order/" + subgame, {
        order: cloneDeep(obj),
      });
      console.log(resp);

      if (resp.status == 200) {
        (
          await this.$utils.toast("Đặt vé thành công", {
            position: "top",
            color: "success",
          })
        ).present();
      } else {
        if (resp.data && resp.data.message) {
          (
            await this.$utils.toast(resp.data.message, { position: "top" })
          ).present();
          if (resp.data.err && resp.data.err == "INSUFFICIENT_FUND")
            this.$utils.askDeposit(this.$router);
        } else {
          (
            await this.$utils.toast(
              "Có lỗi xảy ra từ máy chủ, quý khách vui lòng thử lại sau.",
              { position: "top" }
            )
          ).present();
        }
      }

      this.$utils.hideLoading();
      this.resetCards();
    },
  },
  setup() {
    return {
      trash,
      dice,
      helpCircle,
    };
  },
});
</script>
